import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: {
    uid: undefined,
    balance: 0,
  },
  reducers: {
    setUid: (state, action) => {
      state.uid = action.payload;
    },
    setBalance: (state, action) => {
      state.balance = action.payload;
    },
  },
});

export const { setUid, setBalance } = userSlice.actions;

export default userSlice.reducer;
